import React from 'react';
import { Form, Input } from 'antd';
import { productProperties } from 'config/language';

const { TextArea } = Input;

const Brewing = () => (
  <div className="columns-container">
    <div className="column">
      <Form.Item
        name="malts"
        label={productProperties.malts.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 2 }}
        />
      </Form.Item>
      <Form.Item
        name="hops"
        label={productProperties.hops.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 2 }}
        />
      </Form.Item>
      <Form.Item
        name="tastingNotes"
        label={productProperties.tastingNotes.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 2 }}
        />
      </Form.Item>
    </div>
  </div>
);

export default Brewing;
